import { AxiosResponse } from "../interface";
import { axiosInstanceWebsite } from "../instance";
import { Product } from "../../components/products/ProductInterface";

export const getProducts = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/store/product`
  );
  if (response.data?.length === 0) {
    return [];
  }
  const orderedProducts = response.data?.reverse();
  return orderedProducts;
};

export const putProduct = async (data: Product) => {
    const response: AxiosResponse = await axiosInstanceWebsite.put(
      `/store/product/${data.id}`,
      data
    );
    return response.data;
};

export const cloneProduct = async (productId: string) => {
  const response = await axiosInstanceWebsite.post(
    `/store/product/${productId}/clone`
  );
  return response.data;
};
